import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { List, X, Shield } from '@phosphor-icons/react';

const nav = [
  { to: '/noodsituaties', label: 'Noodsituaties' },
  { to: '/categorieen', label: 'Categorieën' },
  { to: '/beste-keuzes', label: 'Beste keuzes' },
  { to: '/gids', label: 'Gids' },
  { to: '/over-ons', label: 'Over ons' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border"
    >
      <div className="container flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <div className="relative w-9 h-9 bg-primary text-primary-foreground flex items-center justify-center rounded-sm">
            <Shield weight="duotone" size={22} />
            <span className="absolute -bottom-1 -right-1 w-3 h-3 bg-accent rounded-full border-2 border-background" />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-lg tracking-tight">jouw noodpakket<span className="text-accent">.nl</span></div>
            <div className="text-[10px] overline text-muted-foreground hidden sm:block">voor elke crisis</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace('/', '')}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-primary ${isActive ? 'text-primary' : 'text-foreground/80'}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/wizard"
            data-testid="start-wizard-cta-header"
            className="hidden sm:inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-accent-foreground px-4 py-2.5 rounded-sm font-semibold text-sm transition-colors"
          >
            Bouw je pakket
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2 text-foreground"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <div className="container py-4 flex flex-col gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${n.to.replace('/', '')}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base font-medium ${isActive ? 'text-primary' : 'text-foreground/80'}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/wizard"
              onClick={() => setOpen(false)}
              data-testid="start-wizard-cta-mobile"
              className="mt-2 bg-accent text-accent-foreground px-4 py-3 rounded-sm font-semibold text-center"
            >
              Bouw je pakket
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
